import buttonNav from "./buttonNav";
import header from "./header";

export default `
${buttonNav}
${header}
`;
